'use client'

import { MARKETING_NAV_NO_HOME } from '@client/lib/marketing-nav'
import { useSetHeaderConfig } from '@client/providers/header-provider'

/** Installs the marketing nav in the global header. Renders nothing itself. */
export function MarketingNav() {
  useSetHeaderConfig({ navItems: MARKETING_NAV_NO_HOME })
  return null
}
